// extracted by mini-css-extract-plugin
export default {"boxItem":"cards_boxItem__A-0GL","cardsWrap":"cards_cardsWrap__Cf5Kl"};